module.exports = __webpack_public_path__ + "img/replace.13fdc364.svg";